import { gql } from 'graphql-request';

const collections = gql`
  query fetchCollections($page: Int, $pageSize: Int, $tags: [String!]) {
    collections(tags: $tags) {
      totalCount
      objects(page: $page, pageSize: $pageSize) {
        ... on AudiobookList {
          id
          title
          sanitizedDescription
          thumbnailImage
          url
        }
      }
    }
  }
`;

const relatedCollections = gql`
  query fetchRelatedCollections($id: ID!) {
    collection(id: $id) {
      relatedCollections {
        id
        url
        description
        thumbnailImage
        title
      }
    }
  }
`;

const tagCollections = gql`
  query fetchTagCollections($slug: String!) {
    tag(slug: $slug) {
      collections {
        id
        url
        description
        thumbnailImage
        title
      }
    }
  }
`;

export const collectionQueries = {
  collections,
  relatedCollections,
  tagCollections,
};
